"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assumptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const model_1 = require("./model");
const format_1 = require("./format");
const Caution = styled_components_1.default.aside `
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-left: 3px solid ${theme_1.theme.colors.lightBlue};
  border-radius: 4px;
  background: ${theme_1.theme.colors.white};
  padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(3)};
  margin-bottom: ${theme_1.theme.spacing(4)};

  h4 {
    margin: 0 0 6px;
    ${theme_1.theme.fontLabelBold};
    ${theme_1.theme.fontSize(-1)};
    color: ${theme_1.theme.colors.darkBlue};
  }

  p {
    margin: 0 0 ${theme_1.theme.spacing(1)};
    ${theme_1.theme.fontNormal};
    ${theme_1.theme.fontSize(0)};
    color: ${theme_1.theme.colors.dimBlue};
    line-height: 1.6;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
const Footnotes = styled_components_1.default.footer `
  margin-top: ${theme_1.theme.spacing(4)};
  border-top: 1px solid ${theme_1.theme.colors.grey(4)};
  padding-top: ${theme_1.theme.spacing(2)};
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
  line-height: 1.7;

  b {
    ${theme_1.theme.fontLabelBold};
    color: ${theme_1.theme.colors.darkBlue};
  }

  ul {
    margin: 6px 0 0;
    padding-left: 17px;
  }

  li {
    margin: 3px 0;
  }
`;
const ConsentLine = styled_components_1.default.p `
  margin: ${theme_1.theme.spacing(2)} 0 0;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
`;
const Stamp = styled_components_1.default.div `
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-3)};
  letter-spacing: 0.13em;
  text-transform: uppercase;
  margin-top: ${theme_1.theme.spacing(3)};
`;
const Assumptions = ({ result, consentNote, }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Caution, { children: [(0, jsx_runtime_1.jsx)("h4", { children: "Your actual benefit depends on your FuelEU exposure" }), (0, jsx_runtime_1.jsx)("p", { children: "The figures above assume every tonne you switch is burned inside the FuelEU and EU ETS scope. In practice a surplus only arises on energy in scope: all energy used on intra-EEA voyages and at berth in EEA ports, half of the energy on voyages to or from a port outside the EEA, and none outside that. If part of the fuel is burned outside, both the surplus and the ETS saving fall proportionally. Send us your trade pattern and we will run it properly." }), (0, jsx_runtime_1.jsx)("p", { children: "The surplus is valued here at the cost of the compliance deficit it offsets, so the figures assume every tonne displaces a penalty that would otherwise be paid \u2014 whether in your own reporting perimeter or in the pool you supply. If there is no deficit to offset, the surplus is worth whatever a buyer will pay for it instead, which is a negotiated price rather than the penalty rate. Final volumes are whatever your verifier confirms and THETIS-MRV records." })] }), (0, jsx_runtime_1.jsxs)(Footnotes, { children: [(0, jsx_runtime_1.jsx)("b", { children: "How this is calculated." }), " Compliance balance follows FuelEU Maritime Annex IV: (target intensity \u2212 your biofuel intensity) \u00D7 energy delivered in scope, converted to tCO\u2082e.", (0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: "2026 target 89.34 gCO\u2082e/MJ, 2% below the 91.16 baseline." }), (0, jsx_runtime_1.jsx)("li", { children: "Fossil reference values from FuelEU Annex II: HFO/VLSFO 91.70 gCO\u2082e/MJ and 3.114 tCO\u2082/t, LFO 91.40 and 3.151, MDO/MGO 90.77 and 3.206." }), (0, jsx_runtime_1.jsx)("li", { children: "Biofuel replaces the fossil fuel one tonne for one tonne, at an energy content of 37 MJ/kg." }), (0, jsx_runtime_1.jsxs)("li", { children: ["The surplus is valued as direct penalty avoidance at a flat \u20AC", (0, format_1.formatInt)(model_1.PENALTY_EUR_PER_TONNE), " per tCO\u2082e, which is $", (0, format_1.formatInt)(result.penaltyRate), " at the EUR/USD rate above. The statutory figure varies with the attained intensity of the ship and rises by a further 10% for each consecutive year in deficit; we quote a single indicative rate here."] }), (0, jsx_runtime_1.jsx)("li", { children: "The pooled unit price is what a buyer pays for surplus units. It values the same tonnes as the penalty figure does, so the two are shown as alternatives and never summed." }), (0, jsx_runtime_1.jsx)("li", { children: "ETS saving assumes certified sustainable biofuel is zero-rated, at full phase-in." }), (0, jsx_runtime_1.jsx)("li", { children: "No RFNBO multiplier or wind reward factor. Surplus must be verified and reported in THETIS-MRV before it can be pooled." }), (0, jsx_runtime_1.jsx)("li", { children: "The EUA figure is taken from the SparkChange Physical Carbon EUA ETC, which is backed by held allowances and quoted in euros. It tracks the allowance price closely but is not the ICE front-month settlement. FX is the ECB reference rate. Indicative figures only \u2014 not an offer. Unit prices are quoted case by case." })] }), consentNote && (0, jsx_runtime_1.jsx)(ConsentLine, { children: consentNote }), (0, jsx_runtime_1.jsx)(Stamp, { children: "\u00A9 Ahti Climate" })] })] }));
exports.Assumptions = Assumptions;
